/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Automations_TitleInputs */

const en_automations_title = /** @type {(inputs: Automations_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automations`)
};

const pt_br2_automations_title = /** @type {(inputs: Automations_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Automações`)
};

/**
* | output |
* | --- |
* | "Automations" |
*
* @param {Automations_TitleInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const automations_title = /** @type {((inputs?: Automations_TitleInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Automations_TitleInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_automations_title(inputs)
	return pt_br2_automations_title(inputs)
});